var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgF4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 251.5,
    height: 172,
    viewBox: "0 0 251.5 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(-757.5 -2027)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_94",
    "data-name": 94,
    transform: "translate(800.5 2122)",
    fill: "#265c7e",
    fontSize: 80,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -40.88,
    y: 0
  }, "94")), /*#__PURE__*/React.createElement("text", {
    id: "_-",
    "data-name": "-",
    transform: "translate(857 2122)",
    fill: "#265c7e",
    fontSize: 80,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.88,
    y: 0
  }, "-")), /*#__PURE__*/React.createElement("text", {
    id: "_99_",
    "data-name": "99%",
    transform: "translate(939 2122)",
    fill: "#265c7e",
    fontSize: 80,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -69.12,
    y: 0
  }, "99"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300
  }, "%")), /*#__PURE__*/React.createElement("text", {
    id: "of_domestic_violence_survivors",
    "data-name": "of domestic violence survivors",
    transform: "translate(872.5 2152)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -51.88,
    y: 0
  }, "OF DOMESTIC"), /*#__PURE__*/React.createElement("tspan", {
    x: -84.9,
    y: 22
  }, "VIOLENCE SURVIVORS")), /*#__PURE__*/React.createElement("text", {
    id: "have_experienced_financial_abuse",
    "data-name": "have experienced financial abuse",
    transform: "translate(873.5 2196)",
    fill: "#1d1d1d",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -115.268,
    y: 0
  }, "have experienced financial abuse")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF4);
export default __webpack_public_path__ + "static/media/f4.66ce3b8994630ca24c35eb59a056cfc1.svg";
export { ForwardRef as ReactComponent };